import { Message, MessageType } from '@dreryk/react-components';

import { identityDocumentTranslationKeys } from '../../../../../../../../translations';

export const IdentityDocumentOverrideMonit = (): JSX.Element | null => {
   return (
      <Message
         testId={'identityDocumentOverrideMonit'}
         type={MessageType.INFORMATIVE}
         label={identityDocumentTranslationKeys.passport.enter.overrideMonit}
         fullWidth
         displayIndicator
      />
   );
};
